import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import { validateToken, redirectToLogin, initLoginFlow } from '../services/myid-login.service';

const SpaceshipEarthGlobe = () => import("../components/SpaceshipEarthGlobe.vue");
const MissionSpace = () => import("../components/MissionSpace.vue");
const TestTrackPhoto = () => import("../components/TestTrackPhoto.vue");
const TestTrackVideo = () => import("../components/TestTrackVideo.vue");
const Analytics = () => import("../components/Analytics.vue");
const AnalyticsReport = () => import("../components/AnalyticsReport.vue");
const Status = () => import("../components/Status.vue");

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/parklink-landing/spaceship-earth-globe/:date/:id",
    name: "SpaceshipEarthGlobe",
    component: SpaceshipEarthGlobe,
  },
  {
    path: "/parklink-landing/mission-space/:date/:id/:filename/:to/:from",
    name: "MissionSpace",
    component: MissionSpace,
  },
  {
    path: "/parklink-landing/test-track/photo/:date/:id",
    name: "TestTrackPhoto",
    component: TestTrackPhoto,
  },
  {
    path: "/parklink-landing/test-track/video/:date/:id",
    name: "TestTrackVideo",
    component: TestTrackVideo,
  },
  {
    path: "/parklink-analytics",
    name: "analytics",
    component: Analytics,
    beforeEnter: async (to, from, next) => {
      const canActivate = await checkSession();
      if(canActivate) next();
    },
  },
  {
    path: "/parklink-analytics/report/:template/:year/:month",
    name: "analytics-report",
    component: AnalyticsReport,
    beforeEnter: async (to, from, next) => {
      const canActivate = await checkSession();
      if(canActivate) next();
    },
  },
  {
    path: "/parklink-status",
    name: "status",
    component: Status,
    beforeEnter: async (to, from, next) => {
      const canActivate = await checkSession();
      if(canActivate) next();
    },
  }
];

async function checkSession(): Promise<boolean> {
  const url = new URL(window.location.href);
  if (url.searchParams.has('code')) {
    try {
      const result = await initLoginFlow();
      if (result.authenticated) {
        const originalUrl = result.redirectUrl;
        const currentPath = window.location.pathname;
        if (originalUrl) {
          const redirectUrl = new URL(originalUrl);
          // eslint-disable-next-line require-atomic-updates
          window.location.href = redirectUrl.pathname;
          return false;
        }
        // eslint-disable-next-line require-atomic-updates
        window.location.href = currentPath;
        return false;
      }
    } catch (err) {
      console.error('[Auth] OAuth callback failed:', err);
    }
  }

  const isValid = await validateToken();
  if (isValid) {
    return true;
  }

  await redirectToLogin(window.location.href);

  return false;
}

const router = new VueRouter({
  mode: "history",
  routes,
});

export default router;
